/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { ChevronNextIcon, ChevronPreviousIcon } from '@coursera/cds-icons';

type Props = {
  isBack?: boolean;
};

const styles = {
  datePickerNavButton: css`
    padding: 0.5rem;
    width: 2.625rem;
    height: 2.625rem;
    top: 0.75rem;
    position: absolute;
  `,
  forward: css`
    right: 22px;
  `,
  back: css`
    left: 22px;
  `,
};

const DatePickerNavButton = ({ isBack }: Props) => {
  const IconComponent = isBack ? ChevronPreviousIcon : ChevronNextIcon;

  return (
    <IconComponent
      css={[styles.datePickerNavButton, isBack ? styles.back : styles.forward]}
      size="large"
      color="interactive"
      tabIndex={0}
    />
  );
};

export default DatePickerNavButton;
